var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#F4F2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7165 57.2483H37.9102L53.0639 31.314L69.961 22.748L54.7165 57.2483Z",
    fill: "#009AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9104 64.2523H51.9559V60.9087H75.8268L63.6832 45.3673L72.337 25.6201L94.9104 64.2523Z",
    fill: "#007CAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(37.9102 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg8);
export default __webpack_public_path__ + "static/media/fet-img (8).6d6e71c27f173bf2b90ab13f2b0f5ec6.svg";
export { ForwardRef as ReactComponent };